import Image from 'next/image';
import map from 'react-scale/public/static/images/pages/homepage/build-ai/map.png';

export const TabMapping = () => {
  return (
    <Image
      className="bg-black rounded-lg lg:absolute lg:top-1/2 lg:-translate-y-1/2 lg:translate-x-10 3xl:translate-x-18 transition-transform duration-1000 ease-out shadow-xl xl:shadow-super lg:max-w-[50%] xl:max-w-none lg:mb-0 mb-9 select-none"
      src={map}
      alt="A map"
      width={649}
      height={402}
      quality={100}
      placeholder="blur"
    />
  );
};
